import { useLingui } from "@lingui/react";
import { AbsoluteDatePickerProps } from "../types";
import { Box, Button } from "@mui/material";
import { DateCalendar, DateTimeField } from "@mui/x-date-pickers-latest";
import { SelectableMenu } from "./SelectableMenu";
import { msg, Trans } from "@lingui/macro";
import dayjs from "dayjs";

export const AbsoluteDatePicker = ({
  start,
  stop,
  onStartChange,
  onStopChange,
  onError,
  onApply,
  recentRanges,
  disabled,
  onSelectRecent,
}: AbsoluteDatePickerProps) => {
  const { _ } = useLingui();

  return (
    <Box
      border="1px solid"
      borderColor="text.secondary"
      m="-1px"
      borderRadius="0 4px 4px 4px"
    >
      <Box display="flex">
        <Box pt={1.5}>
          <Box px={3}>
            <DateTimeField
              required
              value={start}
              maxDateTime={stop ?? undefined}
              onChange={onStartChange}
              label="Desde"
              fullWidth
              size="small"
              autoFocus
              onError={onError}
            />
          </Box>
          <DateCalendar
            showDaysOutsideCurrentMonth
            disableFuture
            value={start}
            maxDate={stop}
            onChange={onStartChange}
          />
        </Box>

        <Box pt={1.5}>
          <Box px={3}>
            <DateTimeField
              clearable
              value={stop}
              minDateTime={start}
              onChange={onStopChange}
              ampm={false}
              label={_(msg`Hasta (vacío para 'ahora')`)}
              fullWidth
              size="small"
              onError={onError}
            />
          </Box>
          <DateCalendar
            showDaysOutsideCurrentMonth
            disableFuture
            value={stop}
            minDate={start}
            onChange={onStopChange}
          />
        </Box>

      </Box>
      <Box display="flex" justifyContent="end" p={1} gap={2} pr={2.5}>
        <SelectableMenu
          label={_(msg({message: 'Rangos recientes'}))}
          options={recentRanges.map((range) => ({
            label: `${dayjs(range.start).format('YYYY-MM-DD HH:mm')} - ${range.stop ? dayjs(range.stop).format('YYYY-MM-DD HH:mm') : 'now'}`,
            value: range,
          }))}
          onSelect={onSelectRecent}  
        />
        <Button size="small" variant="contained" onClick={onApply} disabled={disabled}>
          <Trans>Aplicar rango</Trans>
        </Button>
      </Box>
    </Box>
  );
}
